import {pulseUserAtom} from 'atoms/auth';
import {loggedInEmployeeAtom} from 'atoms/employee';
import {isUserAdmin} from 'helpers/utils';
import {t} from 'i18next';
import {useAtomValue} from 'jotai';
import {useSidebarCounts, useWorkstreamAudit} from 'views/workstreams/detail/hooks';
import {
  getCombinedWorkstreamAuditAttentionCount,
  isWorkstreamAuditNavEligible,
} from 'views/workstreams/detail/workstreamAuditUtils';

import {RailPlaceRow} from './RailPlaceRow';

/**
 * /workstreams: the rail's Audit row. Shown to the same people as
 * /workstreams' Audit nav item, with its needs-attention count.
 */
export const AuditRailRow = ({
  selected,
  onSelect,
  bleed,
  touch = false,
}: {
  selected: boolean;
  onSelect: () => void;
  bleed: {left: number; right: number};
  touch?: boolean;
}) => {
  const {employee} = useAtomValue(loggedInEmployeeAtom);
  const pulseUser = useAtomValue(pulseUserAtom);
  const {data: sidebarCounts} = useSidebarCounts();
  // The API field name is retained for compatibility; it means any current Audit role.
  const eligible = isWorkstreamAuditNavEligible({
    employeeLevel: employee.level,
    employeeRole: employee.role,
    hasCurrentWorkstreamAuditRole: sidebarCounts?.has_current_exec_sponsor_workstreams ?? false,
    isUserAdmin: isUserAdmin(pulseUser),
  });
  const {data: audit} = useWorkstreamAudit({enabled: eligible});
  const attentionCount = getCombinedWorkstreamAuditAttentionCount(audit);

  if (!eligible) return null;

  return (
    <RailPlaceRow
      label={t('audit')}
      count={attentionCount}
      countLabel={t('workstream_audit_sidebar_attention_badge', {count: attentionCount}).toString()}
      selected={selected}
      onSelect={onSelect}
      bleed={bleed}
      touch={touch}
    />
  );
};
